import { Navigate as RouterRedirect } from 'react-router-dom'
import type { NavigateProps } from 'react-router-dom'

export function Redirect(props: NavigateProps) {
  return <RouterRedirect {...props} />
}
